'use strict';

import './itemProgress.directive.scss';
import ItemProgressTemplate from './itemProgress.directive.html';

export default angular
  .module('maestro.directives.common.itemProgress', [])

  .directive('itemProgress', function() {
    return {
      restrict: 'E',
      template: ItemProgressTemplate,
      replace: true,
      scope: {
        color: '=',
        value: '='
      },
      controller: ($scope, $element) => {
        const elementProgress = $($element).children();
        elementProgress
          .progress({
            percent: $scope.value,
            showActivity: false
          });

        $scope.$watch('value', () => {
          let value = parseInt($scope.value);
          if (isNaN(value) || value == null) {
            value = 0;
          }
          if (value > 100) {
            value = 100;
          } else if (value < 0) {
            value = 0;
          }

          elementProgress
            .progress('set percent', value);
        });

      }
    };
  })

  .name;
